export enum XmlFileFormatEnum {
    VERBOSE_FORMAT = 'Verbose',
    SIMPLIFIED_MINIMALIST_FORMAT = 'Simplified'
}
